import { css } from 'lit';

/**
 * AI Suggestion 系统的完整样式定义
 */
export const suggestionStyles = css`
  .suggestion-button-container {
    position: relative;
    top: 10px;
    left: 0px;
    right: 0;
    z-index: 1000;
  }
  .suggestion-button-container {
    display: flex;
    gap: 40px;
    justify-content: end;
  }
  .suggestion-button-container-wrapper {
    display: flex;
    z-index: 99999;
    width: 88px;
    justify-content: space-around;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    padding: 0px 6px;
    align-items: center;
    height: 24px;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  .suggestion-button-division {
    width: 0.5px;
    height: 18px;
    background-color: #fff;
    opacity: 0.2;
  }
  .suggestion-button-apply {
    color: #fff;
    font-size: 20px;
    width: 20px;
    font-weight: 400;
    height: 20px;
    // padding: 3px 5px;
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .suggestion-old-background {
    opacity: 0.4;
  }

  .suggestion-old-background [data-v-text='true'],
  .suggestion-old-background [data-v-text='true'] * {
    /* 标准删除线 */
    text-decoration-line: line-through;
    /* 可选：更可控的线宽与颜色 */
    text-decoration-thickness: 1.2px;
    text-decoration-color: currentColor;
    /* 避免线条被字体细节跳过 */
    text-decoration-skip-ink: none;
  }
  .suggestion-new-background {
  }
  .suggestion-new-background > div:first-of-type {
    background-color: rgba(0, 188, 255, 0.1);
  }

  .suggestion-all-operation-container {
    display: flex;
    width: 230px;
    z-index: 99999;
    justify-content: space-around;
    background: #00000080;
    border-radius: 20px;
    padding: 6px 12px;
    height: 36px;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  .clickable {
    cursor: pointer;
  }

  .disabled-button {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

/**
 * 注入样式到全局
 */
export function injectSuggestionStyles(): void {
  const styleId = 'affine-suggestion-styles';

  // 检查是否已注入
  if (document.getElementById(styleId)) {
    return;
  }

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = suggestionStyles.cssText;

  document.head.append(style);
}

/**
 * 移除注入的样式
 */
export function removeSuggestionStyles(): void {
  const styleElement = document.getElementById('affine-suggestion-styles');
  if (styleElement) {
    styleElement.remove();
  }
}
